import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { ALL_DOCUMENT_MODES } from '../hooks/useSalesInvoiceRegisterListFilters';

const FilterSelect = ({ labelId, id, label, value, onChange, options }) => (
  <FormControl size="small" sx={{ minWidth: 220 }}>
    <InputLabel id={labelId}>{label}</InputLabel>
    <Select labelId={labelId} id={id} value={value} label={label} onChange={onChange}>
      {options.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

const SalesInvoiceRegisterFilters = ({ documentModeFilter, onDocumentModeFilterChange }) => {
  const { salesInvoiceRegister } = useTranslatedMessages();
  const filterLabels = salesInvoiceRegister?.filters ?? {};
  const tableLabels = salesInvoiceRegister?.table ?? {};

  const sourceOptions = [
    {
      value: ALL_DOCUMENT_MODES,
      label: filterLabels.all_sources ?? 'All Sources',
    },
    {
      value: 'E_INVOICE',
      label: filterLabels.e_invoice ?? tableLabels.source_e_invoice ?? 'E-Invoice',
    },
    {
      value: 'NON_E_INVOICE',
      label:
        filterLabels.non_e_invoice ??
        tableLabels.source_non_e_invoice ??
        filterLabels.register ??
        tableLabels.source_register ??
        'Non-E-Invoice',
    },
  ];

  return (
    <FilterSelect
      labelId="sales-invoice-register-source-filter-label"
      id="sales-invoice-register-source-filter"
      label={filterLabels.source_label ?? 'All Sources'}
      value={documentModeFilter}
      onChange={onDocumentModeFilterChange}
      options={sourceOptions}
    />
  );
};

export default SalesInvoiceRegisterFilters;
